module.exports = __webpack_public_path__ + "static/media/feature-2.a04645ab.svg";